import React, { Fragment } from "react";
import {
  Grid,
  IconButton,
  Dialog as MUIDialog,
  Typography,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";

import Form from "./Form";

export default function OnboardingDialog({ onboardDialog, setOnboardDialog }) {
  const handleClose = () => {
    setOnboardDialog(false);
  };

  return (
    <Fragment>
      <MUIDialog
        open={onboardDialog}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: "900px",
            borderRadius: "12px",
          },
        }}
      >
        <Grid container sx={{ p: 5 }} spacing={3}>
          <Grid item container alignItems="center">
            <Grid size={8}>
              <Typography variant="h4">Onboard Number</Typography>
            </Grid>

            <Grid
              item
              xs={4}
              container
              justifyContent="flex-end"
              alignItems="flex-start"
            >
              <IconButton
                onClick={handleClose}
                disableRipple
                sx={{ padding: "16px 24px" }}
              >
                <Cancel />
              </IconButton>
            </Grid>
          </Grid>

          <Form />
        </Grid>
      </MUIDialog>
    </Fragment>
  );
}
